import { IdPersistence } from "../../constants/IdPersistence";
import { IdUrls } from "../../constants/IdUrls";
import { PlatformType } from "../../features/game-tracking/types/PlatformTypeEnum";
import { utilEnvironment } from "../utilEnvironment";
import { utilPersistence } from "../utilPersistence";
import { IdLang } from "./IdLang";
import { ReplacementLoca } from "./ReplacementLoca";
var LocalizedUrls = /** @class */ (function () {
    function LocalizedUrls() {
        var _this = this;
        this.replacements = {
            lt: IdLang.English,
        };
        this.getLocalizedTermsUrl = function (candidateLang) {
            var lang = _this.replaceUnsupportedLanguages(candidateLang);
            return IdUrls.termsUrl.replace(ReplacementLoca.lang, lang);
        };
        this.getLocalizedPrivacyUrl = function (candidateLang) {
            var lang = _this.replaceUnsupportedLanguages(candidateLang);
            return IdUrls.privacyUrl.replace(ReplacementLoca.lang, lang);
        };
        this.getLocalizedWithdrawalUrl = function (candidateLang) {
            var lang = _this.replaceUnsupportedLanguages(candidateLang);
            return IdUrls.withdrawalUrl.replace(ReplacementLoca.lang, lang);
        };
        this.getLocalizedSupportUrl = function (candidateLang, userName) {
            var lang = _this.replaceUnsupportedLanguages(candidateLang);
            var credentialsData = utilPersistence.getValue(IdPersistence.Credentials, {});
            return utilEnvironment.isDevelopment()
                ? IdUrls.supportUrl + "?g=38&lang=en&platformId=1"
                : IdUrls.supportUrl +
                    "?g=" +
                    credentialsData.gameId +
                    "&platformId=" +
                    PlatformType.WEB +
                    "&lang=" +
                    lang +
                    "&i=" +
                    credentialsData.instanceId +
                    "&n=" +
                    credentialsData.networkId +
                    "&pid=" +
                    credentialsData.playerId +
                    "&uname=" +
                    userName;
        };
        this.replaceUnsupportedLanguages = function (lang) {
            return _this.replacements[lang] || lang;
        };
    }
    return LocalizedUrls;
}());
export var localizedUrls = new LocalizedUrls();



//////////////////
// WEBPACK FOOTER
// ./src/utils/i18n/localizedUrls.ts
// module id = 940
// module chunks = 3